import { useEffect, useState } from "react";
import { GetRoadHome } from "../components/newHome/GetRoadHome";
import NewLicenseJoruney from "../components/newHome/NewLicenseJoruney";
import FlexibleNew from "../components/newHome/FlexibleNew";
import { WhyChooseHome } from "../components/newHome/WhyChooseHome";
import ExpertTutionNew from "../components/newHome/ExpertTutionNew";
import { GuideTestimonials } from "../components/newpages/guide/GuideTestimonials";
import { FaqCsOne } from "../components/faqcsone/FaqCsOne";
import GuideBanner from "../components/newpages/guide/Forward";
import QuickLinks from "../components/newHome/QuickLinks";
export const Home = () => {

  useEffect(()=>{
        window.localStorage.removeItem("prevsUrl")
  },[])

  return (
    <>
    <GetRoadHome/>
    <NewLicenseJoruney/>
    <QuickLinks/>
    <GuideTestimonials textWhite="text-white"/>
    <FaqCsOne content="Got Questions? We’ve Got Answers!"/>
    <GuideBanner content="Get on the road to Freedom!"/>
    </>
  );
};
